import { FunctionComponent } from 'react';
import { withStyles, BodyText, formatAmount } from 'vopay';
import { Button } from 'UI';
import { useTranslation } from 'react-i18next';
import { OpenDialogProps, Dialog } from '@/providers/Dialog.provider';
import CheckCircleIcon from './checkCircle.svg';
import styles from './VirtualAccountInboundSimulationDialog.module.scss';

const cn = withStyles(styles);

type VirtualAccountInboundSimulationDialogProps = OpenDialogProps<void> & {
  currency: string;
  amount: string;
};

const VirtualAccountInboundSimulationDialog: FunctionComponent<VirtualAccountInboundSimulationDialogProps> = ({
  onConfirm,
  currency,
  amount,
}) => {
  const { t } = useTranslation('translations', {
    keyPrefix: 'Accounts.AccountBalances.VirtualAccountInboundSimulationDialog',
  });

  const handleDone = () => {
    onConfirm();
  };

  const formattedAmount = formatAmount(amount);

  return (
    <div className={cn('dialogContent')}>
      <div className={cn('icon')}>
        <img src={CheckCircleIcon} alt="Success" />
      </div>

      <div>
        <Dialog.Title level="3" className={cn('title')}>
          {t('title', {
            currency,
            amount: formattedAmount,
            defaultValue: 'Inbound {{currency}} {{amount}} transfer simulated',
          })}
        </Dialog.Title>

        <BodyText className={cn('description')}>
          {t('description', {
            defaultValue: 'Your virtual account balance will reflect this transfer within 1-2 minutes.',
          })}
        </BodyText>
      </div>

      <div className={cn('buttonContainer')}>
        <Button colorScheme="primary" onClick={handleDone}>
          {t('doneButton', { defaultValue: 'Done' })}
        </Button>
      </div>
    </div>
  );
};

export default VirtualAccountInboundSimulationDialog;
